import { render, staticRenderFns } from "./insurance-primary.vue?vue&type=template&id=a77843d4"
import script from "./insurance-primary.vue?vue&type=script&lang=js"
export * from "./insurance-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports